import { type FC } from 'react'
import { Dropdown } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import {
  actionTeamsFavorite,
  menuTeamsFavorite,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsFavorite'
import {
  actionUngroup,
  menuUngroup,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/Ungroup'
import {
  actionRename,
  menuRename,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/Rename'

type PropsDropDown = {
  inbox: GroupInbox
}

export const DropdownGroupInbox: FC<PropsDropDown> = ({ inbox }) => {
  const store = useConversationMenuContext()
  const entities = useEntitiesContext()

  return (
    <Dropdown
      ariaLabel={'DropdownGroupInbox'}
      icon={'moreHorizontal'}
      placement={'bottom-end'}
      tooltipProps={{
        disableInteractive: true,
        label: 'Show actions',
        placement: 'top-end',
      }}
      items={[menuTeamsFavorite(inbox), menuUngroup(), menuRename()]}
      onChange={(item) => {
        actionTeamsFavorite({ inbox, item }, store)
        actionUngroup({ inbox, item }, store)
        actionRename({ inbox, item, entities })
      }}
      width={inbox.is_favorite ? 128 : 122}
    />
  )
}
